<template>
  <v-dialog
    v-model="show"
    width="60vw"
    :fullscreen="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly"
    scrollable
    persistent
  >
    <v-card
      height="auto"
      elevation="0"
      class="rounded-lg"
      min-height="200"
      v-if="loteSelected"
    >
      <v-card-title
        class="text-h5 lighten-2"
        v-if="loteSelected && loteSelected.loteType == 'BIO'"
      >
        <v-row no-gutters>
          <v-col cols="12"> Actualizar lote {{ loteSelected.loteId }} </v-col>
          <v-col cols="12">
            <span class="text-subtitle-1">Ag Boost</span>
          </v-col>
          <v-col cols="12">
            <span class="text-subtitle-1"
              >Tolva: {{ loteSelected.hopper.name }}</span
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-stepper v-model="stepper" vertical non-linear elevation="0">
            <v-stepper-step
              step="1"
              editable
              :complete="loteSelected.endGrinding ? true : false"
            >
              Molienda</v-stepper-step
            >
            <v-stepper-content step="1">
              <v-container v-if="user.role != 'QUALITY'">
                <v-form ref="formGrinding" lazy-validation>
                  <v-row>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.rawMateria"
                        label="Materia prima (Kg)"
                        :disabled="loteSelected.endGrinding ? true : false"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.phGrinding"
                        :disabled="loteSelected.endGrinding ? true : false"
                        label="pH inicial"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.liquefiedVolume"
                        :disabled="loteSelected.endGrinding ? true : false"
                        label="Volumen licuado (L)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="date"
                        :rules="validation()"
                        v-model="loteSelected.grindingDate"
                        :disabled="loteSelected.endGrinding ? true : false"
                        label="Fecha Molienda"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row justify="end" v-if="!loteSelected.endGrinding">
                  <v-col align="end" cols="12" xl="2" lg="2" md="3">
                    <v-btn color="gray" dark block @click="saveGrindingRequest">
                      Guardar
                    </v-btn>
                  </v-col>
                  <v-col align="end" cols="12" xl="2" lg="2" md="3">
                    <v-btn
                      color="primary"
                      block
                      @click="showGenericConfirmationModalGrinding = true"
                    >
                      Continuar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-else>
                <v-row>
                  <v-col v-if="loteSelected.endGrinding ? true : false">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En proceso producción...</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-step
              step="2"
              editable
              :complete="loteSelected.endFermentation ? true : false"
              v-if="loteSelected.endGrinding"
            >
              Fermentación</v-stepper-step
            >
            <v-stepper-content step="2">
              <v-container v-if="user.role != 'QUALITY'">
                <v-form ref="formFermentation" lazy-validation>
                  <v-row>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.filteredVolume"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="Cantidad filtrada (L)"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.phFermentationStart"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="pH Inicial"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.phFermentationEnd"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="pH Final"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.phFermentation"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="pH ajuste"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.filteredDQO"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="DQO del filtrado"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.DQO"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="Resultado DQO"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="loteSelected.calculatedDQO"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="DQO inicial de digestión"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="date"
                        :rules="validation()"
                        v-model="loteSelected.fermentationDate"
                        :disabled="loteSelected.endFermentation ? true : false"
                        label="Fecha Fermentación"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12">
                      <span class="font-italic" v-if="loteSelected.hopper">
                        Volumen de licor necesario para tolva ({{
                          loteSelected.hopper.name
                        }}):
                        <b>{{ loteSelected.requiredVolume }}</b>
                      </span>
                      <v-spacer></v-spacer>
                      <span v-if="!adviceDQO"
                        >DQO incial digestión: {{ calculatedDQO }}</span
                      >
                      <span v-else
                        >DQO incial digestión:
                        <b class="red--text"
                          >El DQO es más bajo que el minimo (10)</b
                        ></span
                      >
                    </v-col> -->
                  </v-row>
                </v-form>
                <v-row justify="end" v-if="!loteSelected.endFermentation">
                  <v-col align="end" cols="12" xl="2" lg="2">
                    <v-btn
                      color="gray"
                      dark
                      block
                      @click="saveFermentationRequest"
                    >
                      Guardar
                    </v-btn>
                  </v-col>
                  <v-col align="end" cols="12" xl="4" lg="5">
                    <v-btn
                      color="warning"
                      block
                      @click="showGenericConfirmationModalFermentation = true"
                    >
                      Iniciar fermentación anaeróbica
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-else>
                <v-row>
                  <v-col v-if="loteSelected.endFermentation ? true : false">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En proceso producción...</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-step
              step="3"
              editable
              :complete="loteSelected.endDigestion ? true : false"
              v-if="loteSelected.endFermentation"
            >
              Digestión</v-stepper-step
            >
            <v-stepper-content step="3">
              <v-container v-if="user.role != 'QUALITY'">
                <v-row>
                  <v-col cols="12">
                    <span>Agregar registro DQO</span>
                    <v-spacer></v-spacer>
                    <span v-if="loteSelected.calculatedDQO"
                      >DQO incial digestión:
                      {{ parseFloat(loteSelected.calculatedDQO) }}</span
                    >
                    <span v-else>DQO incial digestión: 0</span>
                  </v-col>
                  <v-col v-if="!loteSelected.endDigestion">
                    <v-btn color="primary" @click="addDQO">
                      <v-icon> mdi-plus </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col v-if="errorDigestionLenght">
                    <span class="decrease">
                      Debe de realizarse al menos 3 registros en digestión
                    </span>
                  </v-col>
                </v-row>
                <v-form ref="formDigestion" lazy-validation>
                  <v-row
                    v-for="(item, index) in loteSelected.digestion"
                    :key="index"
                  >
                    <v-col cols="12" xl="4" lg="4" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        v-model="item.ph"
                        type="number"
                        :rules="validation()"
                        :label="'pH seguimiento ' + (index + 1)"
                        :disabled="loteSelected.productionState != 'DIGESTION'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="4" lg="4" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="item.DQO"
                        :label="'Seguimiento DQO ' + (index + 1)"
                        :disabled="loteSelected.productionState != 'DIGESTION'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="4" lg="4">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="date"
                        :rules="validation()"
                        v-model="item.date"
                        :label="'Fecha seguimiento ' + (index + 1)"
                        :disabled="loteSelected.productionState != 'DIGESTION'"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="4" xl="3" lg="3">
                      <v-btn
                        :disabled="item.isValid"
                        @click="saveDigestionRequest(item)"
                        block
                        color="primary"
                        >Validar</v-btn
                      >
                    </v-col> -->
                    <v-col
                      v-if="loteSelected.productionState == 'DIGESTION'"
                      cols="4"
                      xl="3"
                      lg="3"
                    >
                      <v-btn
                        fab
                        x-small
                        color="red"
                        dark
                        @click="removeDQO(index)"
                      >
                        <v-icon> mdi-trash-can </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row justify="end" v-if="!loteSelected.endDigestion">
                  <v-col align="end" cols="12" xl="2" lg="2">
                    <v-btn
                      color="gray"
                      dark
                      block
                      @click="saveDigestionRequest"
                    >
                      Guardar
                    </v-btn>
                  </v-col>
                  <v-col align="end" cols="12" xl="5" lg="5" md="5">
                    <v-btn
                      color="warning"
                      block
                      @click="showGenericConfirmationModalDigestion = true"
                    >
                      Finalizar fermentación
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-else>
                <v-row>
                  <v-col v-if="loteSelected.endDigestion ? true : false">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En proceso producción...</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <!-- <v-stepper-step
              step="4"
              editable
              :complete="true"
              v-if="loteSelected.endDigestion"
            >
              Formulación</v-stepper-step
            > -->
            <!-- <v-stepper-content step="4">
              <v-container>
                <v-row>
                  <v-col>
                    <span
                      >Tolva utilizada:
                      <b>{{ loteSelected.hopper.name }}</b></span
                    >
                    <v-spacer></v-spacer>
                    <span
                      >Total de litros disponibles:
                      <b>{{ loteSelected.totalVolume }}</b></span
                    >
                  </v-col>
                </v-row>
                <v-form ref="formFormulation" lazy-validation>
                  <v-row>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validationNumber()"
                        v-model="litersUsed"
                        label="Litros utilizados"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="date"
                        :rules="validation()"
                        v-model="litersUsedDate"
                        label="Fecha formulación"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row justify="end" v-if="user.role != 'QUALITY'">
                  <v-col align="end" cols="12" xl="5" lg="5" md="5">
                    <v-btn
                      color="primary"
                      block
                      @click="addFormulationRequest"
                      :disabled="isStockAvailable"
                    >
                      Agregar formulación
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content> -->
            <v-stepper-step
              step="4"
              editable
              :complete="true"
              v-if="loteSelected.endDigestion"
            >
              Formulación y Envasado</v-stepper-step
            >
            <v-stepper-content step="4">
              <v-container v-if="!showPackaging">
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-col>
                        <span
                          >Tolva utilizada:
                          <b>{{ loteSelected.hopper.name }}</b></span
                        >
                        <v-spacer></v-spacer>
                        <span
                          >Total de litros de licor disponibles:
                          <b>{{ loteSelected.totalVolume }}</b></span
                        >
                      </v-col>
                    </v-row>
                    <v-form ref="formFormulation" lazy-validation>
                      <v-row>
                        <v-col cols="12" xl="6" lg="6" md="6">
                          <v-text-field
                            dense
                            outlined
                            clearable
                            type="number"
                            :rules="validationNumber()"
                            v-model="litersUsed"
                            label="Litros utilizados"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" xl="6" lg="6" md="6">
                          <v-text-field
                            dense
                            outlined
                            clearable
                            type="date"
                            :rules="validation()"
                            v-model="litersUsedDate"
                            label="Fecha formulación"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-row justify="end" v-if="user.role != 'QUALITY'">
                      <v-col align="end" cols="12" xl="5" lg="5" md="5">
                        <v-btn
                          color="primary"
                          block
                          @click="addFormulationRequest"
                          :disabled="isStockAvailable"
                        >
                          Agregar formulación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-data-table
                      fixed-header
                      height="200px"
                      :headers="headers"
                      :items="formulations"
                      :items-per-page="10"
                      no-data-text="No hay formulaciones"
                      loading-text="Cargando formulaciones..."
                      :page.sync="page"
                      hide-default-footer
                      :loading="fetchingData"
                      :item-class="row_classes"
                      show-expand
                      :single-expand="true"
                      :expanded.sync="expanded"
                      item-key="_id"
                    >
                      <template #[`item.user`]="{ item }">
                        <span
                          >{{ item.user.name }} {{ item.user.lastName }}</span
                        >
                      </template>
                      <template #[`item.numberOfUnitsPackaged`]="{ item }">
                        <span>
                          {{ item.packed.length }}
                        </span>
                      </template>
                      <template #[`item.actions`]="{ item }">
                        <v-btn
                          color="primary"
                          small
                          @click="
                            (showPackaging = true), (formulationSelected = item)
                          "
                        >
                          <v-icon> mdi-package-variant-closed-plus</v-icon>
                        </v-btn>
                      </template>
                      <template #expanded-item="{ headers, item }">
                        <td class="px-0 py-2" :colspan="headers.length">
                          <template>
                            <v-data-table
                              :headers="headersChild"
                              :items="item.packed"
                              item-key="_id"
                              no-data-text="No hay envasados"
                              hide-default-footer
                              elevation="0"
                            >
                              <template #[`item.user`]="{ item }">
                                <span>{{ item.user }} </span>
                              </template>
                            </v-data-table>
                          </template>
                        </td>
                      </template>
                    </v-data-table>
                    <v-pagination
                      v-model="page"
                      :length="numPages"
                      total-visible="10"
                      color="primary"
                    ></v-pagination>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      @click="showGenericConfirmationModalFinshLote = true"
                      :disabled="loteSelected.productionState == 'STOCK_PT'"
                    >
                      Finalizar lote
                    </v-btn>
                  </v-col>
                </v-row>
                <div
                  v-if="
                    loteSelected.productionState == 'STOCK_PT' &&
                    user.role == 'PRODUCTION'
                  "
                >
                  <v-form ref="formRemoveStock" lazy-validation>
                    <!-- <v-row>
                      <v-col>
                        <v-text-field
                          dense
                          clearable
                          outlined
                          :disabled="loteSelected.stock <= 0"
                          v-model="stockeRemoved"
                          label="Ingresa stock a remover (litros)"
                          :rules="validationNumber('stock')"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-btn
                          color="warning"
                          block
                          :disabled="loteSelected.stock <= 0"
                          @click="removeStockRequest"
                        >
                          Remover
                        </v-btn>
                      </v-col>
                    </v-row> -->
                    <v-row class="pt-0 mt-0">
                      <v-col>
                        <span class="font-weight-bold text-body-2">
                          Stock actual:
                        </span>
                        {{ loteSelected.stock }}
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
              </v-container>
              <v-container v-if="showPackaging">
                <v-row>
                  <v-col>
                    <v-btn
                      fab
                      x-small
                      color="primary"
                      @click="
                        (showPackaging = !showPackaging), fetchFormulations()
                      "
                    >
                      <v-icon small> mdi-arrow-left </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span>
                      Formulado disponible:
                      {{ formulationSelected.litersStock }} L
                    </span>
                  </v-col>
                  <v-col v-if="advicePackaging">
                    <span class="red--text">
                      No se puede envasar más de lo que hay stock
                    </span>
                  </v-col>
                </v-row>
                <v-form ref="formPacking" lazy-validation>
                  <v-row>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="number"
                        :rules="validation()"
                        v-model="packingLitersUsed"
                        label="Litros envasados"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-text-field
                        dense
                        outlined
                        clearable
                        type="date"
                        :rules="validation()"
                        v-model="packingLitersUsedDate"
                        label="Fecha formulación"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row justify="end">
                  <v-col align="end" cols="12" xl="5" lg="5" md="5">
                    <v-btn color="primary" block @click="addPackingRequest">
                      Añadir envasado
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-step
              step="6"
              editable
              :complete="true"
              v-if="loteSelected.endDigestion"
            >
              Registro bidones</v-stepper-step
            >
            <v-stepper-content step="6">
              <v-container fluid v-if="user.role == 'QUALITY'">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span>
                      Estatus validación:
                      <div v-if="isValid != null">
                        <span v-if="isValid == true" class="primary--text">
                          Cumple
                        </span>
                        <span v-else class="red--text"> No cumple </span>
                      </div>
                      <div v-else>
                        <span>--</span>
                      </div>
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span>Peso ideal (g): 5140.0</span>
                  </v-col>
                  <v-col cols="12">
                    <span>Peso promedio (g): {{ averageDrums }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span>Diferencia con el ideal (g) {{ gapDrums }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      rounded
                      @click="addDrum"
                      :disabled="loteSelected.isDrumsRegisterEnd"
                    >
                      <v-icon> mdi-plus </v-icon>
                      Agregar registro peso
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="gray"
                      rounded
                      @click="endDrumsRegisterRequest(false)"
                      :disabled="loteSelected.isDrumsRegisterEnd"
                      :dark="loteSelected.isDrumsRegisterEnd ? false : true"
                    >
                      <v-icon> mdi-content-save</v-icon>
                      Guardar
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="warning"
                      rounded
                      @click="endDrumsRegisterRequest(true)"
                      :disabled="loteSelected.isDrumsRegisterEnd"
                    >
                      <v-icon> mdi-receipt-text-clock-outline </v-icon>
                      Finalizar registro
                    </v-btn>
                  </v-col>
                </v-row>
                <div class="scroll-row mt-4">
                  <v-form ref="formDrumsRegister" lazy-validation>
                    <v-row
                      v-for="(item, index) in loteSelected.drums"
                      :key="index"
                      class="mt-2"
                    >
                      <v-col>
                        <v-text-field
                          dense
                          outlined
                          clearable
                          :label="`Bidón ${index + 1}`"
                          v-model="item.value"
                          type="number"
                          :rules="validationNumber('campo')"
                          :disabled="loteSelected.isDrumsRegisterEnd"
                        ></v-text-field>
                      </v-col>
                      <v-col v-if="!loteSelected.isDrumsRegisterEnd">
                        <v-btn
                          color="red"
                          dark
                          small
                          @click="deleteDrum(index)"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
              </v-container>
              <v-container v-else>
                <v-row>
                  <v-col v-if="loteSelected.isDrumsRegisterEnd">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso bidones calidad finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>Proceso bidones calidad en proceso...</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
          </v-stepper>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" block @click="closeModal" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <GenericConfirmationModalGrinding
      v-model="showGenericConfirmationModalGrinding"
      @confirmation="finishGrindingRequest"
      :title="'¿Estás seguro que quieres pasar a fermentación?'"
    />
    <GenericConfirmationModalFermentation
      v-model="showGenericConfirmationModalFermentation"
      @confirmation="finishFermentationRequest"
      :title="'¿Estás seguro que quieres pasar a Digestión?'"
    />
    <GenericConfirmationModalDigestion
      v-model="showGenericConfirmationModalDigestion"
      @confirmation="finishDigestionRequest"
      :title="'¿Estás seguro que quieres pasar a Formulación y envasado?'"
    />
    <GenericConfirmationModalFinshLote
      v-model="showGenericConfirmationModalFinshLote"
      @confirmation="handleFinishFertilizerLote"
      :title="'¿Estás seguro que quieres finalizar el lote?'"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
//components
import GenericConfirmationModalGrinding from "@/components/utils/GenericConfirmationModal.vue";
import GenericConfirmationModalFermentation from "@/components/utils/GenericConfirmationModal.vue";
import GenericConfirmationModalDigestion from "@/components/utils/GenericConfirmationModal.vue";
import GenericConfirmationModalFinshLote from "@/components/utils/GenericConfirmationModal.vue";
//validations
import {
  requiredValidation,
  requiredMultiple,
  numberValidation,
} from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//qr library
import qrcode from "qrcode-generator";
export default {
  components: {
    GenericConfirmationModalGrinding,
    GenericConfirmationModalFermentation,
    GenericConfirmationModalDigestion,
    GenericConfirmationModalFinshLote,
  },
  data: () => ({
    averageDrums: 0,
    gapDrums: 0,
    user: JSON.parse(localStorage.getItem("user")),
    stepper: 1,
    page: 1,
    numPages: 1,
    fetchingData: false,
    licor: null,
    DQO: null,
    calculatedDQO: 0,
    adviceDQO: false,
    litersUsed: null,
    litersUsedDate: null,
    packingLitersUsed: null,
    packingLitersUsedDate: null,
    showPackaging: false,
    formulationSelected: null,
    formulations: [],
    expanded: [],
    errorDigestionLenght: false,
    showGenericConfirmationModalGrinding: false,
    showGenericConfirmationModalFermentation: false,
    showGenericConfirmationModalDigestion: false,
    showGenericConfirmationModalFinshLote: false,
    advicePackaging: false,
    headers: [
      {
        text: "Litros formulados",
        align: "center",
        value: "litersUsed",
        sortable: false,
      },
      {
        text: "Litros Stock",
        align: "center",
        value: "litersStock",
        sortable: false,
      },
      {
        text: "Número de envasados",
        align: "center",
        value: "numberOfUnitsPackaged",
        sortable: false,
      },
      {
        text: "Fecha formulación",
        align: "center",
        value: "packingDate",
        sortable: false,
      },
      {
        text: "Usuario",
        align: "center",
        value: "user",
        sortable: false,
      },
      {
        text: "Envasar formulado",
        align: "center",
        value: "actions",
        sortable: false,
      },
    ],
    headersChild: [
      {
        text: "Litros envasados",
        align: "center",
        value: "packingLitersUsed",
        sortable: false,
      },
      {
        text: "Fecha envasado",
        align: "center",
        value: "packingLitersUsedDate",
        sortable: false,
      },
      {
        text: "Usuario",
        align: "center",
        value: "user",
        sortable: false,
      },
    ],
    isStockAvailable: false,
    isValid: null,
    stockeRemoved: null,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("lotes", ["loteSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    if (this.loteSelected) {
      if (this.loteSelected.productionState == "GRINDING") {
        this.stepper = 1;
      } else if (this.loteSelected.productionState == "FERMENTATION") {
        this.stepper = 2;
      } else if (this.loteSelected.productionState == "DIGESTION") {
        this.stepper = 3;
      } else if (this.loteSelected.productionState == "FORMULATION") {
        this.stepper = 4;
      }
    }
  },
  methods: {
    ...mapActions("lotes", [
      "saveGrinding",
      "finishGrinding",
      "saveFermentation",
      "finishFermentation",
      "saveDigestion",
      "finishDigestion",
      "addFormulation",
      "addPackaging",
      "getFormulations",
      "endDrumsRegister",
      "removeStock",
      "finishFertilizerLote",
    ]),
    ...mapMutations("lotes", ["SET_LOTE_SELECTED", "SET_FETCH_LOTES_LIST"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationNumber() {
      return numberValidation({ min: 1, required: true });
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    addDQO() {
      this.loteSelected.digestion.push({
        ph: null,
        DQO: null,
        date: null,
        isValid: false,
      });
    },
    removeDQO(index) {
      this.loteSelected.digestion.splice(index, 1);
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    async saveGrindingRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          rawMateria: this.loteSelected.rawMateria,
          phGrinding: this.loteSelected.phGrinding,
          liquefiedVolume: this.loteSelected.liquefiedVolume,
          grindingDate: this.loteSelected.grindingDate,
        };
        let response = await this.saveGrinding(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Datos guardados!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async saveFermentationRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          filteredVolume: this.loteSelected.filteredVolume,
          phFermentation: this.loteSelected.phFermentation,
          phFermentationStart: this.loteSelected.phFermentationStart,
          phFermentationEnd: this.loteSelected.phFermentationEnd,
          DQO: this.loteSelected.DQO,
          filteredDQO: this.loteSelected.filteredDQO,
          requiredVolume: this.loteSelected.requiredVolume,
          fermentationDate: this.loteSelected.fermentationDate,
          calculatedDQO: this.loteSelected.calculatedDQO,
        };
        let response = await this.saveFermentation(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Datos guardados!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async saveDigestionRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          digestion: this.loteSelected.digestion,
        };
        let response = await this.saveDigestion(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Datos guardados!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async addFormulationRequest() {
      if (this.$refs.formFormulation.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            litersUsed: this.litersUsed,
            date: this.litersUsedDate,
          };
          let response = await this.addFormulation(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.litersUsed = null;
            this.litersUsedDate = null;
            this.$refs.formFormulation.resetValidation();
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Formulación añadida!!",
              timeout: 3500,
            });
            await this.fetchFormulations();
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al añadir`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al añadir`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async addPackingRequest() {
      if (this.$refs.formPacking.validate()) {
        if (
          this.formulationSelected.litersStock - this.packingLitersUsed >=
          0
        ) {
          this.advicePackaging = false;
          try {
            let payload = {
              loteId: this.loteSelected._id,
              user: this.user._id,
              formulationId: this.formulationSelected._id,
              packingLitersUsed: this.packingLitersUsed,
              packingLitersUsedDate: this.packingLitersUsedDate,
            };

            let response = await this.addPackaging(payload);
            if (response) {
              this.packingLitersUsed = null;
              this.packingLitersUsedDate = null;
              this.formulationSelected.litersStock = response.stock;
              this.SET_LOTE_SELECTED(response.lote);
              this.SET_FETCH_LOTES_LIST(true);
              this.litersUsed = null;
              this.litersUsedDate = null;
              this.$refs.formPacking.resetValidation();
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "Envasado añadido!!",
                timeout: 3500,
              });
            } else {
              this.$swal({
                icon: "error",
                title: `Algo salio mal al añadir`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          } catch (error) {
            console.log(error);
            this.$swal({
              icon: "error",
              title: `Algo salio mal al añadir`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.advicePackaging = true;
        }
      }
    },
    async fetchFormulations() {
      try {
        this.fetchingData = true;
        let payload = {
          loteId: this.loteSelected._id,
          page: this.page,
        };
        let response = await this.getFormulations(payload);
        if (response) {
          this.formulations = response.formulations;
          this.numPages = response.pages;
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar formulaciones`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar formulaciones`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    async finishGrindingRequest() {
      if (this.$refs.formGrinding.validate()) {
        await this.saveGrindingRequest();
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
          };

          let response = await this.finishGrinding(payload);
          if (response) {
            this.stepper = 2;
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Envasado añadido!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal, intente de nuevo !!`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal, intente de nuevo !!`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async finishFermentationRequest() {
      if (this.$refs.formFermentation.validate()) {
        await this.saveFermentationRequest();
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
          };

          let response = await this.finishFermentation(payload);
          if (response) {
            this.stepper = 3;
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Fermentación finalizada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal, intente de nuevo !!`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal, intente de nuevo !!`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async finishDigestionRequest() {
      if (
        this.$refs.formDigestion.validate() &&
        this.loteSelected.digestion.length >= 3
      ) {
        try {
          this.errorDigestionLenght = false;
          await this.saveDigestionRequest();
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
          };
          let response = await this.finishDigestion(payload);
          if (response) {
            this.stepper = 4;
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Digestion finalizada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal, intente de nuevo !!`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal, intente de nuevo !!`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } else {
        if (this.loteSelected.digestion.length < 3) {
          this.errorDigestionLenght = true;
        } else {
          this.errorDigestionLenght = false;
        }
      }
    },
    addDrum() {
      this.loteSelected.drums.push({
        value: null,
      });
    },
    deleteDrum(index) {
      this.loteSelected.drums.splice(index, 1);
    },
    async endDrumsRegisterRequest(isDone) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          drums: this.loteSelected.drums,
          isDone: isDone,
        };
        let validation = true;
        if (isDone) {
          validation = this.$refs.formDrumsRegister.validate();
        }
        if (validation) {
          let response = await this.endDrumsRegister(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            if (isDone) {
              this.$swal({
                icon: "success",
                title: `Registro finalizado!!`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.show = false;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "Información guardada!!!",
                timeout: 3500,
              });
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar registro`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al finalizar registro`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async removeStockRequest() {
      if (this.$refs.formRemoveStock.validate()) {
        let payload = {
          loteId: this.loteSelected._id,
          stockToRemove: this.stockeRemoved,
        };
        let response = await this.removeStock(payload);
        if (!response) throw response;
        this.stockeRemoved = null;
        this.$refs.formRemoveStock.resetValidation();
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Stock actualizado exitosamente",
          timeout: 3500,
        });
      }
    },
    async handleFinishFertilizerLote() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
        };
        let response = await this.finishFertilizerLote(payload);
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.$swal({
          icon: "success",
          title: `Lote finalizado!!`,
          showConfirmButton: false,
          timer: 2000,
        });
        this.show = false;
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al finalizar lote`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
  watch: {
    async stepper(value) {
      if (value == 4) {
        await this.fetchFormulations();
      }
    },
    litersUsed() {
      if (this.litersUsed) {
        let total =
          parseFloat(this.loteSelected.totalVolume) -
          parseFloat(this.litersUsed);

        let flag = total < 0 ? true : false;
        this.isStockAvailable = flag;
      }
    },
    "loteSelected.drums": {
      handler: function (val) {
        this.averageDrums = 0;
        this.gapDrums = 0;
        if (val.length > 0) {
          for (let item of val) {
            if (
              item.value != null &&
              item.value != undefined &&
              item.value.length > 0
            ) {
              this.averageDrums += parseFloat(item.value);
            }
          }
          this.averageDrums = (this.averageDrums / val.length).toFixed(2);
          let minWeight = 4980;
          let maxWeight = 5500;
          this.isValid =
            this.averageDrums >= minWeight && this.averageDrums <= maxWeight;
          this.gapDrums = 5140.0 - this.averageDrums;

          this.gapDrums = this.gapDrums.toFixed(2);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.decrease {
  color: red;
}
.scroll-row {
  max-height: 200px; /* Altura máxima de la fila */
  overflow-y: auto; /* Agrega un scroll vertical */
}
</style>
>
